(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('CartHTTPService', CartHTTPService);

    CartHTTPService.$inject = ['$http', 'API_URL'];

    function CartHTTPService($http, API_URL) {
        var service = {
            save: save
        };

        return service;

        function save(data) {
            return $http({
                method: 'POST',
                url: API_URL + 'cart',
                data: data
            });
        }
    }
})();
